import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const ONE_MINUTE = 60000;
const ONE_HOUR = ONE_MINUTE * 60;

const appIdDev = '1:704293990901:web:bd574edc89f1e1ba3d30bc';
const appIdAcc = '1:704293990901:web:da69bb82649c53323d30bc';
const appIdProd = '1:704293990901:web:97b44da126d09e3f3d30bc';

const getAppId = (environment: string) => {
  if (environment === 'dev') return appIdDev;
  if (environment === 'acc') return appIdAcc;
  if (environment === 'prod') return appIdProd;
  return appIdDev;
};

export function getRemoteConfigByEnvironment(environment: string) {
  const firebaseConfig = {
    apiKey: 'AIzaSyAGHIdSPSErDGrGLdIF8ltlUGHZcLAk5q4',
    authDomain: 'provider-extranet-wallonia.firebaseapp.com',
    projectId: 'provider-extranet-wallonia',
    storageBucket: 'provider-extranet-wallonia.firebasestorage.app',
    messagingSenderId: '704293990901',
    appId: getAppId(environment),
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    minimumFetchIntervalMillis: ONE_HOUR,
    fetchTimeoutMillis: ONE_MINUTE,
  };

  return remoteConfig;
}
